<!--
 * @Author: your name
 * @Date: 2020-09-11 15:32:49
 * @LastEditTime: 2020-09-15 21:30:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\vehicleDaily.vue
-->
<template>
    <div class="vehicleDaily">
        <div class="search-conditions-con">
            <div class="search-conditions">
                <span class="time-con" @click="showCalendarPop=true">
                    <span>{{ date }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
        </div>
        <div class="main">
            <div class="sum-data">
                <div
                    class="station-item"
                >
                    <div class="name">
                        总计
                    </div>
                    <div class="nums">
                        <div>
                            <h5>{{ sumData.volumns }}</h5>
                            <p>运输方量</p>
                        </div>
                        <div>
                            <h5>{{ sumData.car_count }}</h5>
                            <p>运行车辆数</p>
                        </div>
                        <div>
                            <h5>{{ sumData.carriage_count }}</h5>
                            <p>运送趟数</p>
                        </div>
                        <div>
                            <h5>{{ sumData.distance }}</h5>
                            <p>公里数</p>
                        </div>
                    </div>
                </div>
            </div>

            <template v-for="(item, index) in vehicleClass">
                <div
                    class="vehicle-item"
                    :key="index"
                    :class="`item${index}`"
                >
                    <h4>{{ item.type }}</h4>
                    <template v-for="(v,vIndex) in item.stations">
                        <div
                            class="station-item"
                            :key="`${v.type_id}_${vIndex}`"
                            v-if="v.datas.length>0"
                        >
                            <div class="name">
                                {{ v.station }}
                            </div>
                            <div class="nums">
                                <div>
                                    <h5>{{ v.datas[0].volumns }}</h5>
                                    <p>运输方量</p>
                                </div>
                                <div>
                                    <h5>{{ v.datas[0].car_count }}</h5>
                                    <p>运行车辆数</p>
                                </div>
                                <div>
                                    <h5>{{ v.datas[0].carriage_count }}</h5>
                                    <p>运送趟数</p>
                                </div>
                                <div>
                                    <h5>{{ v.datas[0].distance }}</h5>
                                    <p>公里数</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="split" :key="`split_${index}`"></div>
            </template>
            <div class="chart-con">
                <h4>
                    <van-tabs
                        type="card"
                        color="#3495FB"
                        v-model="tabActive"
                        @click="tabSelect"
                    >
                        <template
                            v-for="(item,index) in tabData"
                        >
                            <van-tab :key="index" :title="item.name" :disabled="item.disabled"></van-tab>
                        </template>
                    </van-tabs>
                </h4>
                <div class="chart">
                    <div id="chartDom"></div>
                </div>
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择年月日"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 选择时间1
            showCalendarPop: false,
            // 选择组织结构
            showOrgPop: false,
            // 当前日期
            date: '',
            // 选中组织结构
            orgName: '淮海运营区-鲁东片区-东营商混',
            columns: [
                {
                    text: '请选择',
                    children: [
                        {
                            text: '',
                            children: [{
                                text: '',
                            }],
                        },
                    ],
                },
            ],
            // 组织机构
            orgData: [],
            yun_yq_id: '',
            pian_q_id: '',
            qi_y_id: 'OT000072',
            dic_code: '',
            currentDate: new Date(),
            tabActive: 0,
            // tab选项
            tabData: [
                {
                    name: '运输方量',
                    disabled: false,
                },
                {
                    name: '运行车辆数',
                    disabled: false,
                },
                {
                    name: '运送趟数',
                    disabled: false,
                },
                {
                    name: '公里数',
                    disabled: false,
                },
            ],
            // 车辆分类
            vehicleClass: [],
            // 方量
            volumns: {
                自有车辆: [],
                临时车辆: [],
                租赁车辆: [],
            },
            // 运输车辆数
            car_count: {
                自有车辆: [],
                临时车辆: [],
                租赁车辆: [],
            },
            // 运送趟数
            carriage_count: {
                自有车辆: [],
                临时车辆: [],
                租赁车辆: [],
            },
            // 公里数
            distance: {
                自有车辆: [],
                临时车辆: [],
                租赁车辆: [],
            },
            // x轴数据
            xData: [],
            // 汇总数据
            sumData: {
                volumns: 0,
                car_count: 0,
                carriage_count: 0,
                distance: 0,
            },
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.date = util.currentTimeFormat('yyyy-MM-dd');
            this.getOrg();
            this.handleDayReport();
        },
        // 获取组织机构数据
        async getOrg() {
            const yyq = await this.getOrgApi();
            if (yyq) {
                this.orgData = yyq;
                const res = this.handleOrg([yyq[1]]);
                this.columns.push(res[0]);
            }
        },
        // 处理组织结构数据
        handleOrg(data) {
            const res = data.map(item => {
                item.text = item.dic_name;
                if (item.dic_name === '请选择') {
                    item.children = [
                        {
                            text: '请选择',
                        },
                    ];
                } else if (item.children) {
                    item.children = this.handleOrg(item.children);
                }
                return item;
            });
            return res;
        },
        // 处理日报数据
        async handleDayReport() {
            const res = await this.getDayReport();
            if (res) {
                if (res.length > 0) {
                    const objTypes = [];
                    const objStations = [];
                    for (let i = 0; i < res.length; i++) {
                        const typeItem = res[i];
                        if (typeItem.volumns) {
                            this.sumData.volumns = Number(this.sumData.volumns) + Number(typeItem.volumns);
                        }
                        if (typeItem.car_count) {
                            this.sumData.car_count = Number(this.sumData.car_count) + Number(typeItem.car_count);
                        }
                        if (typeItem.carriage_count) {
                            this.sumData.carriage_count = Number(this.sumData.carriage_count) + Number(typeItem.carriage_count);
                        }
                        if (typeItem.distance) {
                            this.sumData.distance = Number(this.sumData.distance) + Number(typeItem.distance);
                        }
                        if (objTypes.indexOf(typeItem.type_name) === -1) {
                            objTypes.push(typeItem.type_name);
                        }

                        if (objStations.indexOf(typeItem.station_name_short) === -1) {
                            objStations.push(typeItem.station_name_short);
                        }
                    }
                    const arry = [];
                    for (let i = 0; i < objTypes.length; i++) {
                        const typeName = objTypes[i];
                        const obj = {
                            type: typeName,
                            stations: [],
                        };
                        for (let j = 0; j < objStations.length; j++) {
                            const stationName = objStations[j];
                            const stationObj = {
                                station: stationName,
                                datas: [],
                            };
                            const rList = res.filter(item => item.type_name === typeName && item.station_name_short === stationName);
                            // eslint-disable-next-line max-depth
                            if (rList.length > 0 ) {
                                stationObj.datas.push(rList[0]);

                            }
                            obj.stations.push(stationObj);
                        }
                        arry.push(obj);
                    }
                    this.vehicleClass = arry;
                    this.xData = objStations;
                    for (const key in this.volumns) {
                        const arr = this.vehicleClass.filter(item => item.type === key);
                        const stations = arr[0].stations;
                        const volumnsValues = [];
                        stations.map(item => {
                            if (item.datas.length > 0) {
                                volumnsValues.push(item.datas[0].volumns);
                            } else {
                                volumnsValues.push(0);
                            }
                        });
                        this.volumns[key] = volumnsValues;
                    }
                    for (const key in this.car_count) {
                        const arr = this.vehicleClass.filter(item => item.type === key);
                        const stations = arr[0].stations;
                        const volumnsValues = [];
                        stations.map(item => {
                            if (item.datas.length > 0) {
                                volumnsValues.push(item.datas[0].car_count);
                            } else {
                                volumnsValues.push(0);
                            }
                        });
                        this.car_count[key] = volumnsValues;
                    }
                    for (const key in this.carriage_count) {
                        const arr = this.vehicleClass.filter(item => item.type === key);
                        const stations = arr[0].stations;
                        const volumnsValues = [];
                        stations.map(item => {
                            if (item.datas.length > 0) {
                                volumnsValues.push(item.datas[0].carriage_count);
                            } else {
                                volumnsValues.push(0);
                            }
                        });
                        this.carriage_count[key] = volumnsValues;
                    }
                    for (const key in this.distance) {
                        const arr = this.vehicleClass.filter(item => item.type === key);
                        const stations = arr[0].stations;
                        const volumnsValues = [];
                        stations.map(item => {
                            if (item.datas.length > 0) {
                                volumnsValues.push(item.datas[0].distance);
                            } else {
                                volumnsValues.push(0);
                            }
                        });
                        this.distance[key] = volumnsValues;
                    }
                    this.reloadChart(this.volumns, '方');
                }

            }

        },
        // 图表切换
        tabSelect(name) {
            if (name === 0) {
                this.reloadChart(this.volumns, '方');
            } else if (name === 1) {
                this.reloadChart(this.car_count, '辆');
            } else if (name === 2) {
                this.reloadChart(this.carriage_count, '趟');
            } else if (name === 3) {
                this.reloadChart(this.distance, '公里');
            }
        },
        // 重载图表
        reloadChart(data, unit) {
            const data2 = {
                id: 'chartDom',
                xData: this.xData,
                yAxisName: [unit],
                grid: {
                    left: 50,
                    top: 50,
                    right: 30,
                    bottom: 40,
                },
                series: [
                    {
                        name: '自有车辆',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#55A7FE', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#3E79C5', // 100% 处的颜色
                            }], false),
                        },
                        label: {
                            show: false,
                        },
                        barMaxWidth: 15,
                        data: data['自有车辆'],
                    },
                    {
                        name: '租赁车辆',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#EFAB54', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#FA8C47', // 100% 处的颜色
                            }], false),
                        },
                        label: {
                            show: false,
                        },
                        barMaxWidth: 15,
                        data: data['租赁车辆'],
                    },
                    {
                        name: '临时车辆',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#71C6B0', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#4EA496', // 100% 处的颜色
                            }], false),
                        },
                        label: {
                            show: false,
                        },
                        barMaxWidth: 15,
                        data: data['临时车辆'],
                    },
                ],
            };
            this.initLineChart(data2);
        },
        // 获取组织结构    
        getOrgApi() {
            const path = '/interfaceApi/report/dictionary/get_dictionary_tree?group_code=jt_data_express_tenant&isAddSelect=true';
            return this.$axios.$get(path, { defEx: true });
        },
        // 获取车辆日报
        getDayReport() {
            const data = {
                date: this.date,
                yun_yq_id: this.yun_yq_id,
                pian_q_id: this.pian_q_id,
                qi_y_id: this.qi_y_id,
            };
            const path = '/interfaceApi/report/tjfx/mrsj/day_report';
            return this.$axios.$post(path, data, { defEx: true });
        },
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = this.formatDate(value);
            this.tabActive = 0;
            this.handleDayReport();
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = date.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        confirmOrg(value) {
            this.showOrgPop = false;
            this.orgName = '';
            if (value[0] && value[0] !== '请选择') {
                this.orgName += value[0];
            } else {
                this.orgName = '全部';
                this.qi_y_id = '';
                this.yun_yq_id = '';
                this.pian_q_id = '';
            }
            if (value[1] && value[1] !== '请选择') {
                this.orgName += '-' + value[1];
            }
            if (value[2] && value[2] !== '请选择') {
                this.orgName += '-' + value[2];
            }

            if (value[2] && value[2] !== '请选择') {
                this.findOrgcode(this.orgData, value[2]);
                this.qi_y_id = this.dic_code;
                this.yun_yq_id = '';
                this.pian_q_id = '';
            } else if (value[1] && value[1] !== '请选择') {
                this.findOrgcode(this.orgData, value[1]);
                this.qi_y_id = '';
                this.yun_yq_id = '';
                this.pian_q_id = this.dic_code;
            } else if (value[0] && value[0] !== '请选择') {
                this.findOrgcode(this.orgData, value[0]);
                this.qi_y_id = '';
                this.yun_yq_id = this.dic_code;
                this.pian_q_id = '';
            }
            this.tabActive = 0;
            this.handleDayReport();
        },
        findOrgcode(data, name) {
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                if (item.dic_code === '') {continue;}
                if (item.dic_name === name) {
                    this.dic_code = item.dic_code;
                } else if (item.children && item.children.length > 0) {
                    this.findOrgcode(item.children, name);
                }
            }
        },
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 量价结构分析
        initLineChart(data) {
            const myChart = this.$echarts.init(document.getElementById(data.id));
            const option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: data.legend,
                },
                grid: data.grid,
                xAxis: [
                    {
                        type: 'category',
                        data: data.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [],
                series: data.series,
            };
            if (data) {
                data.yAxisName.forEach(item => {
                    option.yAxis.push({
                        name: item,
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                    },);
                });
            }
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="stylus">
.vehicleDaily
    background #fff
    width 100%
    height 100%
    .search-conditions-con
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                position relative
                text-align center
                padding-right 15rpx
                font-size 14rpx
                width 100rpx
                &:after
                    content ''
                    position absolute
                    right 0
                    top 1rpx
                    height 15rpx
                    border-right 1px solid #D7D7D7
                    margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                text-align center
                width calc(100% - 100rpx)
                .org-name
                    color #3495FB
                    font-size 14rpx
    .main
        height calc(100% - 65rpx)
        overflow-y auto
        .sum-data
            padding 15rpx 15rpx 0 15rpx
            .station-item
                margin-bottom 0
                border 1px solid rgba(250, 140, 71, 0.1)
                background rgba(250, 140, 71, 0.04)
                .name
                    background #FA8C47
                .nums
                    >div
                        h5
                            color #FA8C47
                .name
                    &:after
                        background none

        .vehicle-item
            padding 15rpx
            h4
                font-size 18rpx
                margin-bottom 16rpx
        .station-item
            border 1px solid rgba(62, 103, 198, 0.1)
            border-radius 4rpx
            background rgba(62, 103, 198, 0.04)
            height 50rpx
            margin-bottom 10rpx
            .name
                width 30rpx
                padding 0 4rpx
                background #3E67C6
                font-size 12rpx
                color #fff
                height 100%
                writing-mode vertical-lr /*从左向右 从右向左是 writing-mode: vertical-rl;*/
                writing-mode tb-lr /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
                text-align center
                line-height 22px
                border-radius 4rpx 0 0 4rpx
                position relative
                float left
                &:after
                    content ''
                    position absolute
                    top -1px
                    left -2px
                    width 32rpx
                    height 28rpx
                    background url(./../../../assets/images/homeLd/station.png) no-repeat
                    background-size 100% 100%
            .nums
                float left
                width calc(100% - 30rpx)
                height 100%
                display flex
                >div
                    flex 1
                    h5
                        text-align center
                        font-size 15rpx
                        color #3E67C6
                        margin 5rpx 0 2rpx 0
                    p
                        text-align center
                        font-size 12rpx
                        color #666666
        .item0
            .station-item
                border 1px solid rgba(62, 103, 198, 0.1)
                background rgba(62, 103, 198, 0.04)
                .name
                    background #3E67C6
                .nums
                    >div
                        h5
                            color #3E67C6
        .item1
            .station-item
                border 1px solid rgba(78, 164, 150, 0.1)
                background rgba(78, 164, 150, 0.04)
                .name
                    background #4EA496
                .nums
                    >div
                        h5
                            color #4EA496
        .item2
            .station-item
                border 1px solid rgba(48, 137, 204, 0.1)
                background rgba(48, 137, 204, 0.04)
                .name
                    background #3495FB
                .nums
                    >div
                        h5
                            color #3495FB
        .split
            height 15rpx
            background #F0F0F0
        .chart-con
            min-height 100rpx
            padding-bottom 20rpx
            .van-tabs
                margin 15rpx 0
            .chart
                #chartDom
                    width 100%
                    height 200rpx
</style>